

















import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import ApiClient from '@/data/ApiClient';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import Project from '@/classes/Project';
import { TunnelGroup, TunnelGroupsClient } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    Datagrid,
  },
})
export default class ContractsTable extends Vue {
  @Prop({required: true})
  public project!: Project;

  @Prop({ required: false, default: false})
  public disabled!: boolean;

  tunnelGroups: TunnelGroup[] = [];

  public async created() {
    this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
  }

  public openDetails(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && this.project) {
      this.$router.push({ path: `/contracts/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}` });
    }
  }

  public deleteContract(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {

        if (e && e.data && e.data.documentNumber) {
          const documentnumber: string = (e.data.documentNumber as string)
            .replace('/', '-')
            .replace('/', '-');

          await ApiClient.projects.contracts.delete(e.data.documentNumber);

          notificationService.saved();
        }

        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        reject(false);
      }
    });
  }

  get columns() {
    return [
      {
        dataField: 'documentNumber',
        caption: 'Documentnr.',
      },
      {
        dataField: 'subcontractorName',
        caption: 'Onderaannemer',
      },
      {
        dataField: 'date',
        caption: 'Datum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: {
          displayExpr: 'text',
          valueExpr: 'value',
          items: ApiClient.projects.contracts.getStatusOptions(),
        },
      },
      {
        dataField: 'projectType',
        caption: 'Soort project',
      },
      {
         dataField: 'reference',
        caption: 'Referentie',
      },
      {
        dataField: 'measuringStateRef',
        caption: this.$t('objects.contracts.fields.MeasuringStateRef'),
      },
      {
        dataField: 'tunnelGroupsId',
        caption: this.$t('objects.contracts.fields.TunnelGroup'),
        lookup: {
          dataSource: this.tunnelGroups,
          displayExpr: 'name',
          valueExpr: 'id',
        },
      },
      {
        dataField: 'contractType',
        caption: this.$t('objects.contracts.fields.ContractType'),
      },
      {
        dataField: 'total',
        caption: this.$t('objects.contracts.fields.Total'),
        dataType: 'number',
        alignment: 'left',
        format: {
          type: 'currency',
          precision: 2,
        },
      },
    ];
  }
}
